import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["viewBox"]
const _hoisted_2 = { "clip-path": "url(#clip0_2267_22335)" }
const _hoisted_3 = ["stroke"]
const _hoisted_4 = ["stroke"]
const _hoisted_5 = { id: "clip0_2267_22335" }

import { PropType } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'searchIcon',
  props: {
  color: {
    type: String as PropType<string>,
    default: "#000000",
  },
  size: {
    type: Number as PropType<number>,
    default: 15,
  },
  svgClass: {
    type: String as PropType<string>,
    default: "",
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    style: _normalizeStyle(`max-width: ${__props.size}px; max-height: ${__props.size}px; min-width: ${__props.size}px; min-height: ${__props.size}px; display: flex; align-items: center;`)
  }, [
    (_openBlock(), _createElementBlock("svg", {
      style: {"width":"100%","height":"100%"},
      class: _normalizeClass(__props.svgClass),
      viewBox: `0 0 ${__props.size} ${__props.size}`,
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      _createElementVNode("g", _hoisted_2, [
        _createElementVNode("path", {
          d: "M8.34729 11.3435C11.2264 10.1199 12.5685 6.79401 11.3449 3.91489C10.1213 1.03576 6.79537 -0.306309 3.91624 0.91729C1.03712 2.14089 -0.304952 5.46681 0.918648 8.34593C2.14225 11.2251 5.46816 12.5671 8.34729 11.3435Z",
          stroke: __props.color,
          "stroke-width": "0.9375",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, _hoisted_3),
        _createElementVNode("path", {
          d: "M10.1367 10.1406L14.5298 14.5344",
          stroke: __props.color,
          "stroke-width": "0.9375",
          "stroke-linecap": "round",
          "stroke-linejoin": "round"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("defs", null, [
        _createElementVNode("clipPath", _hoisted_5, [
          _createElementVNode("rect", {
            style: _normalizeStyle(`width: ${__props.size}px;height: ${__props.size}px;`),
            fill: "white"
          }, null, 4)
        ])
      ])
    ], 10, _hoisted_1))
  ], 4))
}
}

})